import { Pause, Phone, Play } from "lucide-react";
import { useSamples } from "./SamplesContext";

export const Wave = ({ on, n = 18 }) => (
  <div className={`wave flex h-7 items-center ${on ? "on" : ""}`} aria-hidden="true">
    {Array.from({ length: n }).map((_, i) => <span key={i} />)}
  </div>
);

export default function IncomingCallCard({ compact = false }) {
  const { samples, current, playing, play } = useSamples();
  const s = samples[current];
  return (
    <aside className={`glass-card w-full rounded-3xl text-[var(--cream)] ${compact ? "p-4" : "p-5"}`} data-testid="incoming-call-card" aria-label="Sample incoming call">
      <div className="flex items-center gap-2 text-xs uppercase tracking-[0.18em] text-[var(--cream)]/70">
        <span className="pulse-dot h-2 w-2 rounded-full bg-[var(--orange)]" /> Incoming call
        <span className="ml-auto rounded-full bg-[var(--orange)] px-2 py-0.5 text-[10px] font-bold tracking-wider text-white" data-testid="incoming-sample-badge">SAMPLE</span>
      </div>
      <div className="mt-4 flex items-center gap-3">
        <div className="grid h-11 w-11 place-items-center rounded-full bg-white/10"><Phone size={18} /></div>
        <div>
          <p className="font-semibold leading-tight" data-testid="incoming-caller">{s?.caller || "Sample call"}</p>
          <p className="text-xs text-[var(--cream)]/60">{s ? `${s.label} · to ${s.patient}` : "Loading sample…"}</p>
        </div>
      </div>
      <p className={`font-te mt-3 text-[13px] text-[var(--cream)]/85 ${compact ? "line-clamp-2" : "line-clamp-4"}`} data-testid="incoming-call-text">{s?.text || "…"}</p>
      <div className="mt-4 flex items-center gap-3">
        <button onClick={() => play(current)} data-testid="incoming-play-btn" className="btn-orange grid h-12 w-12 shrink-0 place-items-center rounded-full" aria-label={playing ? "Pause sample" : "Play sample"}>
          {playing ? <Pause size={20} /> : <Play size={20} className="ml-0.5" />}
        </button>
        <Wave on={playing} />
        <span className="ml-auto text-xs tabular-nums text-[var(--cream)]/60">~{Math.round(s?.est_seconds || 0)}s</span>
      </div>
    </aside>
  );
}
